import { getGetMeQueryOptions } from '@amarantos/api-client'
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { z } from 'zod/v3'

import { AuthShell } from '@/features/auth/components/auth-shell'
import { LoginForm } from '@/features/auth/components/login-form'
import { useLoginMutation } from '@/features/auth/hooks/use-login-mutation'
import { getSafeRedirectUrl } from '@/features/auth/utils/redirect'

const loginSearchSchema = z.object({
	redirect: z.string().optional(),
})

export const Route = createFileRoute('/login')({
	validateSearch: loginSearchSchema,
	beforeLoad: async ({ context, search }) => {
		const user = await context.queryClient.ensureQueryData(getGetMeQueryOptions()).catch(() => null)

		if (user) {
			throw redirect({
				to: getSafeRedirectUrl(search.redirect),
			})
		}
	},
	component: LoginRoute,
})

function LoginRoute() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { redirect: redirectParam } = Route.useSearch()

	const loginMutation = useLoginMutation(() => {
		navigate({ to: getSafeRedirectUrl(redirectParam) })
	})

	return (
		<AuthShell title={t('auth.login.title')} description={t('auth.login.description')}>
			<LoginForm
				isSubmitting={loginMutation.isPending}
				onSubmit={async (values) => {
					await loginMutation.mutateAsync({ data: values })
				}}
			/>
		</AuthShell>
	)
}
